import { render, staticRenderFns } from "./DevBpbjStandardInfoModal.Style#Drawer.vue?vue&type=template&id=3c836078&scoped=true&"
import script from "./DevBpbjStandardInfoModal.Style#Drawer.vue?vue&type=script&lang=js&"
export * from "./DevBpbjStandardInfoModal.Style#Drawer.vue?vue&type=script&lang=js&"
import style0 from "./DevBpbjStandardInfoModal.Style#Drawer.vue?vue&type=style&index=0&id=3c836078&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c836078",
  null
  
)

export default component.exports